var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitehourglassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H0.75C0.3125 0 0 0.34375 0 0.75V1.25C0 1.6875 0.3125 2 0.75 2C0.75 4.84375 2.34375 7.25 4.5 8C2.34375 8.78125 0.75 11.1875 0.75 14C0.3125 14 0 14.3438 0 14.75V15.25C0 15.6875 0.3125 16 0.75 16H11.25C11.6562 16 12 15.6875 12 15.25V14.75C12 14.3438 11.6562 14 11.25 14C11.25 11.1875 9.625 8.78125 7.46875 8C9.625 7.25 11.25 4.84375 11.25 2C11.6562 2 12 1.6875 12 1.25V0.75C12 0.34375 11.6562 0 11.25 0ZM8.875 12H3.09375C3.625 10.5625 4.71875 9.5 6 9.5C7.25 9.5 8.34375 10.5625 8.875 12ZM8.875 4H3.09375C2.84375 3.40625 2.75 2.71875 2.75 2H9.25C9.25 2.71875 9.125 3.40625 8.875 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitehourglassIcon);
export default __webpack_public_path__ + "static/media/whitehourglass-icon.62affc8d420c603e0afc32661dc16d86.svg";
export { ForwardRef as ReactComponent };